// Copyright (c) 2025 - Present. Hardfin, Inc. All rights reserved.
// Hardfin Confidential - Restricted
import { MultiTimezoneTooltip } from '@/components/multi-timezone-tooltip';
import { AccessTimeOutlined } from '@/constants/hardfin-standard-icons';
import { Stack, Typography, useTheme } from '@mui/material';
import { DateTime } from 'luxon';

interface FormattedTimeValueProps {
  timestamp: DateTime;
  format?: string;
}

/**
 * Displays a formatted timestamp with a clock icon and multi-timezone tooltip.
 * Provides a consistent date display pattern across the application.
 */
export function FormattedTimeValue(props: FormattedTimeValueProps) {
  const { timestamp, format = 'medium' } = props;
  const theme = useTheme();

  const formattedDate =
    format === 'medium'
      ? timestamp.toLocaleString({ dateStyle: 'medium' })
      : timestamp.toFormat(format);

  return (
    <MultiTimezoneTooltip timestamp={timestamp}>
      <Stack
        component="span"
        direction="row"
        alignItems="center"
        spacing={0.5}
        sx={{ display: 'inline-flex' }}
      >
        <Typography variant="body2" component="span">
          {formattedDate}
        </Typography>
        <AccessTimeOutlined
          fontSize="small"
          sx={{ color: theme.palette.grey[400] }}
        />
      </Stack>
    </MultiTimezoneTooltip>
  );
}
